/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_silent_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the anagram of SILENT?`)
};

const es_wu_c_silent_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es el anagrama de SILENT?`)
};

const de_wu_c_silent_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist das Anagramm von SILENT?`)
};

const nl_wu_c_silent_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het anagram van SILENT?`)
};

const fr_wu_c_silent_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est l'anagramme de SILENT ?`)
};

const it_wu_c_silent_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è l'anagramma di SILENT?`)
};

const pt_br2_wu_c_silent_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o anagrama de SILENT?`)
};

const pt_wu_c_silent_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o anagrama de SILENT?`)
};

const ja_wu_c_silent_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENTのアナグラムは何ですか？`)
};

const zh_wu_c_silent_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT 的易位构词是什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_silent_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_silent_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_silent_faq1_q", locale)
	if (locale === "en") return en_wu_c_silent_faq1_q(inputs)
	if (locale === "es") return es_wu_c_silent_faq1_q(inputs)
	if (locale === "de") return de_wu_c_silent_faq1_q(inputs)
	if (locale === "nl") return nl_wu_c_silent_faq1_q(inputs)
	if (locale === "fr") return fr_wu_c_silent_faq1_q(inputs)
	if (locale === "it") return it_wu_c_silent_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_silent_faq1_q(inputs)
	if (locale === "pt") return pt_wu_c_silent_faq1_q(inputs)
	if (locale === "ja") return ja_wu_c_silent_faq1_q(inputs)
	return zh_wu_c_silent_faq1_q(inputs)
};